export default __webpack_public_path__ + "static/media/circulo1.b49410c5.svg";